import { useAuthStore } from '../../../store';
import HeaderFilter from '../../../components/HeaderFilter';
import DisplayTable from '../../../components/core/DisplayTable';
import GenericForm from '../../../components/core/GenericForm';

// Admin / Configuration — Security Module Keys master.
const SecurityModuleKeysPage = () => {
  const api = '/security/module-keys';
  const moduleName = 'Security Module Keys';
  const { user } = useAuthStore();
  const isAdmin = user?.role === 'ROLE_ADMIN';
  return (
    <div className={'page-wrapper'}>
      <HeaderFilter showCreate={isAdmin} />
      <DisplayTable
        api={api}
        moduleName={moduleName}
        canDelete={isAdmin}
        canEdit={isAdmin}
        userRole={user?.role}
      />
      <GenericForm api={api} moduleName={moduleName} />
    </div>
  );
};

export default SecurityModuleKeysPage;
